module.exports = __webpack_public_path__ + "img/britannica-imagequest.0d970bd4.png";